define('pages/claim/Physician/PhysicianComponent',[
	'jquery',
	'core/can',
	'models/Physician',
	'text!pages/claim/Physician/PhysicianView.stache',
	'typeahead'
], function($, can, NPI, PhysicianView) {
	
	can.Component.extend({
		
		tag: 'claim-physician',
		
		template: PhysicianView,
		
		scope: function(attrs) {
			
			return can.Map({
				
				ClaimPhysician: attrs.physician,
				
				EditPhysician: null,
				
				isEditing: false,
				
				isEmpty: can.compute(function() {
					var p = attrs.physician;
					return !p.attr('Name.First') && !p.attr('Name.Last') && !p.attr('Npi');
				})
			})
		},
		
		events: {
			
			getSearch: function() {
				return $(this.element).find('input[can-value="EditPhysician.Npi"]');
			},
			
			'.phys-edit click': function(el, ev) {
				
				this.scope.attr({
					'isEditing': true,
					'EditPhysician': this.scope.attr('ClaimPhysician').attr()
				});
				
				this.getSearch().typeahead({ 
					highlight: true, 
					hint: false,
					minLength: 3,
					limit: 10
				},{
					source: NPI.search,
					displayKey: function(datum) {
						return datum.Id.toString();
					},
					templates: {
						suggestion: function(datum) {
							return '<p>' + datum.LastName + ', ' + datum.FirstName + '<br>' + datum.Id + '</p>';
						},
						empty: '<div style="padding:1em">No physicians found.</div>',
					}
				});
			},
			
			'.phys-cancel click': function(el, ev) {
				this.scope.attr('isEditing', false);
				this.clear();
			},
			
			'.phys-clear click': 'clear',
			
			clear: function() {
				this.scope.attr('EditPhysician', new NPI);
			},
			
			'.phys-done click': function(el, ev) {
				
				var p = this.scope.attr('EditPhysician').attr();
				this.scope.attr('ClaimPhysician').attr({
					Name: p.Name,
					Npi: p.Npi
				});

				this.scope.attr('isEditing', false);
				this.clear();
			},
			
			'typeahead:selected': function(el, ev, datum, dataset) {
				this.scope.attr('EditPhysician', new NPI({
					Name: {
						Last: datum.LastName,
						First: datum.FirstName
					},
					Npi: datum.Id.toString()
				}));
				
				// Flash
				var els = this.element.find('input').addClass('flash');
				window.setTimeout(function() {
					els.removeClass('flash');
				}, 4000);
			}
		}
	});
});
